const deleteTenants = {
  toastr: 'Tenant eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteTenants;
